<template>
  <div>
    <v-row>
      <v-col v-for="i in 4" :key="`sk-stat-${i}`" cols="12" sm="6" md="3">
        <v-card outlined class="pa-4">
          <v-skeleton-loader type="avatar" class="mb-4 bg-transparent"></v-skeleton-loader>
          <v-skeleton-loader
            type="heading"
            class="mb-2 bg-transparent"
            height="28"
          ></v-skeleton-loader>
          <v-skeleton-loader type="text" class="bg-transparent" width="60%"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8">
        <v-card
          v-for="i in 3"
          :key="`sk-main-${i}`"
          :class="{ 'mb-4': i < 3 }"
          outlined
          class="pa-4"
        >
          <v-skeleton-loader
            type="subtitle"
            width="40%"
            class="mb-4 bg-transparent"
          ></v-skeleton-loader>
          <v-skeleton-loader class="mx-4" type="divider"></v-skeleton-loader>
          <v-skeleton-loader type="paragraph@2" class="bg-transparent"></v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="mb-4 pa-4" outlined>
          <v-skeleton-loader type="subtitle" class="bg-transparent"></v-skeleton-loader>
          <v-skeleton-loader
            type="image"
            height="160"
            class="mt-4 bg-transparent"
          ></v-skeleton-loader>
        </v-card>

        <v-card class="mb-4 pa-4" outlined>
          <v-skeleton-loader type="subtitle" class="bg-transparent"></v-skeleton-loader>
          <v-skeleton-loader
            type="image"
            height="160"
            class="mt-4 bg-transparent"
          ></v-skeleton-loader>
        </v-card>

        <v-card outlined class="pa-4">
          <v-skeleton-loader
            type="subtitle"
            width="60%"
            class="mb-2 bg-transparent"
          ></v-skeleton-loader>
          <v-divider></v-divider>
          <v-skeleton-loader
            v-for="i in 6"
            :key="`sk-sub-${i}`"
            type="list-item-avatar"
            class="my-2 bg-transparent"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script setup lang="ts"></script>
